import WomanImg from '../assets/images/defaults/woman.svg';
import ManImg from '../assets/images/defaults/man.svg';
import CorporateImg from '../assets/images/defaults/corporate.svg';

export const ContactTypeEnum = {
  woman: {
    value: 'woman',
    defaultImg: WomanImg,
  },
  man: {
    value: 'man',
    defaultImg: ManImg, 
  },
  corporate: {
    value: 'corporate',
    defaultImg: CorporateImg,
  },
};
